import { Component } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { ProgressService } from './service/progress.service';
 
import * as CryptoJS from 'crypto-js';
import { LoginService } from '../../../../components/login/service/login.service';
@Component({
  selector: 'app-progress-monitor',
  templateUrl: './progress-monitor.component.html',
  styleUrl: './progress-monitor.component.scss'
})
export class ProgressMonitorComponent {

  data: any = [];

  progressTableData: any = [];

  userDetails: any;

  destroyEvent: Subscription=new Subscription();
  bodySpinner: boolean = false;
  constructor(
    private progressService: ProgressService,
    private service:LoginService
  ) {
      let user = localStorage.getItem("user");
                if(user){
                  var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
                  this.userDetails = JSON.parse(data);
                }   
   // this.userDetails = this.appComponent.userDetailsAppComp;
 
  }

  ngOnInit(){
    this.bodySpinner=true;
    const number = timer(0, 10000);
    this.destroyEvent = number.subscribe((sub) => {
      this.progressService.getProgress().subscribe(
        {
          next: (response) => {
            this.progressTableData = response;
            this.progressTableData.reverse();
          },
      
          error: (err: any) => { },
          complete: () => {this.bodySpinner=false; }
        }
      );
    });
  }

  ngAfterViewInit(){
    
  }

  ngOnDestroy() {
    this.destroyEvent.unsubscribe();
  }
}
